import { Box, Paper } from '@mui/material';
import { styled } from '@mui/system';

export const ContactSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.appBackgroundDark || 'linear-gradient(135deg, #0D0221 0%, #190835 50%, #2D1155 100%)')
    : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
}));

export const ContactPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: '20px',
  boxShadow: theme.palette.mode === 'dark' ? (theme.custom?.shadows?.softDark || '0 10px 30px rgba(0, 0, 0, 0.35)') : '0 10px 30px rgba(0, 0, 0, 0.1)',
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.bgDark || 'rgba(255, 255, 255, 0.06)')
    : 'rgba(255, 255, 255, 0.9)',
  border: theme.palette.mode === 'dark' ? (theme.custom?.glass?.borderDark || '1px solid rgba(255,255,255,0.10)') : undefined,
  backdropFilter: theme.palette.mode === 'dark' ? (theme.custom?.glass?.blur || 'blur(14px)') : 'blur(10px)',
}));

export const ContactInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  color: theme.palette.mode === 'dark' ? '#BB86FC' : theme.palette.primary.main,
}));

export const SocialIcons = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(3),
}));
